import React from "react";
import { useMsal } from "@azure/msal-react";
import { useLocation } from "react-router-dom";

import { useAuthContext } from "../../hooks/authContext";

import HeaderView from "./index.view";

function Header() {

  const { user } = useAuthContext();
  const { instance } = useMsal();

  const location = useLocation();

  const pickTab = () => {
    if (location.pathname === "/") {
      return 0;
    }
    if (location.pathname.includes("/capability-analysis")) {
      return 1;
    }

    if (location.pathname.includes("/approved-feedstock")) {
      return 2;
    }

    if (location.pathname.includes("/raw-materials")) {
      return 3;
    }
    if (location.pathname.includes("/feedstock-quality")) {
      return 4;
    }

    return 0;
  };

  const [currentTab, selectTab] = React.useState(pickTab());

  React.useEffect(() => {
    const currentTab = pickTab();
    selectTab(currentTab);
  }, [location.pathname]);


  const onLogout = React.useCallback(() => {
    instance.logout();
  }, [instance]);

  const onChangeTab = React.useCallback(
    (event: React.SyntheticEvent<Element, Event>, newTab: number) => {
      selectTab(newTab);
    },
    [selectTab]
  );

  const tabsOptions = React.useMemo(() => {
    return [
      { label: "Purchase Opportunities", to: "/" },
      { label: "Capability Analysis", to: "/capability-analysis" },
      { label: "Approved Feestock", to: "/approved-feedstock" },
      { label: "Raw materials ranking", to: "/raw-materials" },
      { label: "Feedstock Quality", to: "/feedstock-quality" },
    ];
  }, []);

  return (
    <HeaderView
      currentTab={currentTab}
      userEmail={user?.username || (user?.name as string)}
      onLogout={onLogout}
      tabsOptions={tabsOptions}
      onChangeTab={onChangeTab}
    />
  );
}

export default React.memo(Header);
